import ProtectedRoute from "@components/ProtectedRoute";
import { useIsInclude } from "src/router/RoutersCst";

import ThirdParts from "@pages/Contents/ThirdParts";
import LTIAccount from "@pages/Contents/ThirdParts/LTIAccounts";
import AddLTIAccount from "@pages/Contents/ThirdParts/LTIAccounts/Add";
import EditLTIAccount from "@pages/Contents/ThirdParts/LTIAccounts/Edit";

const useThirdPartyRoutes = () => {
  const { user, isInclude } = useIsInclude();
  return {
    path: "third-parts",
    children: [
      {
        index: true,
        path: "",
        // loader: () => ({
        //   title: PagesID["third-parts"],
        // }),
        element: (
          <ProtectedRoute isAllowed={!!user}>
            <ThirdParts />
          </ProtectedRoute>
        ),
      },
      {
        path: "lti-accounts",
        children: [
          {
            index: true,
            path: "",
            // loader: () => ({
            //   title: PagesID["third-parts"],
            // }),
            element: (
              <ProtectedRoute isAllowed={!!user}>
                <LTIAccount />
              </ProtectedRoute>
            ),
          },
          {
            index: true,
            path: "add",
            // loader: () => ({
            //   title: PagesID["third-parts"],
            // }),
            element: (
              <ProtectedRoute isAllowed={!!user}>
                <AddLTIAccount />
              </ProtectedRoute>
            ),
          },
          {
            index: true,
            path: "edit/:idLTIAccount",
            // loader: () => ({
            //   title: PagesID["third-parts"],
            // }),
            element: (
              <ProtectedRoute isAllowed={!!user}>
                <EditLTIAccount />
              </ProtectedRoute>
            ),
          },
        ],
      },
    ],
  };
};

export default useThirdPartyRoutes;
